import { Injectable } from '@angular/core';
import { Log } from '../models/log.model';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { TenantService } from 'src/app/tenant/tenant.service';
import { AuthService } from 'src/app/core/account/auth.service';
import { take } from 'rxjs/operators';
import { getLocaleDateFormat } from '@angular/common';
import { GlobalService } from './global.service';

@Injectable({ providedIn: 'root' })
export class LogService {
  apiHost: string = environment.apiHost;

  constructor(private http: HttpClient, private globalService: GlobalService) {}

  addToLog(location: string, message: any): Promise<Log> {
    let tenant = this.globalService.currentTenant;
    let user = this.globalService.currentUser;
    if (tenant == null) tenant = '';
    if (user == null) user = '';
    let log: Log = new Log();
    log.tenant = tenant;
    log.creationUser = user;
    log.location = location;
    log.logMessage = JSON.stringify(message);
    let promise = new Promise<Log>((resolve, reject) => {
      return this.http
        .post<Log>(this.apiHost + '/log/AddToLog', log)
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            reject('Internal Error: Log not functioning!');
          }
        );
    });
    return promise;
  }
}
